<template>
  <div class=" is-fullwidth">
    
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Range</th>
          <th>Colourway</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Cost (EUR)</th>
          <th>Location</th>
          <th>Export (<span @click="checkAll()" style="cursor:pointer;text-decoration:underline" >Check All</span>)</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="11" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="11" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in orders" v-bind:key="order.orderID">
              <td >
                  <a :href="ASP_URL + '/createpdforder-internal.php?txtPONumber=' + order.ponumber + '&MODE=VIEW'" target="_blank"><button class="button is-small is-info" :disabled="working===true" >PDF</button></a>
              </td>
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td :class="{'has-text-danger' : order.garmentname == 'Historical Leisurewear'}">{{order.garmentname}}</td>
          <td>{{order.range_name}}</td>
          <td>{{order.design_colourway}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
           <td>{{ order.unit_cost }}</td>
          <td>{{ order.makeup_location_name }}</td>
          <td>
            <input type="checkbox" class="checkbox exportordercheckbox" v-model="order.checked"  :disabled="exported==true" value="1" v-if="order.garmentname != 'Historical Leisurewear' && checkValidGarment(order) != false"/>
            
            <a v-if="checkValidGarment(order) == false " :href="ASP_URL + '/sales/order/viewdesign?designID=' + order.designID + '&clientID=' +  order.clientID + '&returnUrl=' + APP_URL + '/production/export-scheduler'"><div class="button is-small is-danger" >Garment Invalid</div></a>

            <a v-if="1==2 && order.garmentname == 'Historical Leisurewear'" :href="ASP_URL + '/sales/order/viewdesign?designID=' + order.designID + '&clientID=' +  order.clientID + '&returnUrl=' + APP_URL + '/production/export-scheduler'"><button class="button is-small is-link">Update</button></a>
          </td>
          
          
              
			</tr>
    	</tbody>
        <tfoot>
            <tr>
                <td colspan="10">&nbsp;</td>
                <td>
                  <button class="button is-success is-small" @click="exportXLS()" v-if="filteredOrders.length > 0 && this.exported == false">Export to CSV</button>
                  <button class="button is-danger is-small" @click="refreshPage()" v-if="this.exported == true">Refresh Page</button>
                </td>
            </tr>
        </tfoot>
    </table>

    <table class="table is-hoverable is-fullwidth is-size-7" id="exporttable" style="">
    	<thead>
    		<tr>
        <th>Order_No</th>
        <th>Sales_Rep</th>
   	 		<th>Customer</th>
          <th>Order_Description</th>
          <th>Design_Name</th>
          <th>RangeCode</th>
          <th>StyleCode</th>
          <th>TeamCode</th>
          <th>Colourway</th>
          <th>Quantity</th>
          <th>Price</th>
          <th>Date_Ordered</th>
          <th>Date_Required</th>
          <th>Garment_Type</th>
        </tr>
    	</thead>
    	<tbody>
		   
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
        
               <td >{{order.ponumber}}</td>
               <td>{{ order.firstname }} {{  order.surname }}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{order.sku_range_code}}</td>
          <td>{{order.style_code}}</td>
          <td>{{order.team_code}}</td>
          <td>{{order.design_colourway}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{ order.unit_cost}}</td>
          <td>{{order.orderdate_export}}</td>
          <td>{{order.deliverydate_export}}</td>
          <td>
            <span v-if="order.fully_printed==1">fully_printed</span>
            <span v-else-if="order.part_printed==1">part_printed</span>
            <span v-else>cut_sew</span>
          </td>
             
			</tr>
    	</tbody>
        
    </table>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      APP_URL : process.env.VUE_APP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: '',
      accessToken: '',
      exported : false
    }
  },
   methods: {
    checkValidGarment(order) {
      if(order.garmentname == "Historical Leisurewear")
      {
        return false
      }
      else if(order.sku_range_id > 0 && order.style_id > 0 )
      {
        if(order.design_colourway == "" || order.design_colourway == "." || order.design_colourway == " ")
        {
          return false
        }
        else{
          return true
        }
      }
      else{
        return false
      }
      
    },
    
    checkAll() {
      
      for (var i = 0; i < this.orders.length; i++) {
          if(this.checkValidGarment(this.orders[i]) == true)
          {
            this.orders[i].checked = true
          }
          
        }
    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getProductionOrdersToExport(this.accessToken, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      exportXLS() {
		 //alert("hi")
		var wb = XLSX.utils.table_to_book(document.getElementById('exporttable'), {raw:true});
		 XLSX.writeFile(wb, 'Scheduler Export.csv', {'bookType': 'csv'})

         // Update database with exported flag
         this.updateExportedOrders()
	 },
   refreshPage() {
      this.exported = false
      this.getOrders()
   },
     updateExportedOrders() {
        this.working = true

        var formdata = { 
            _method: 'patch',
             field_to_set: 'exported_to_scheduler',
             value: 1,
             order_ids: this.ordersToUpdate
        }; 

        OrderService.updateMultiOrder(this.accessToken, formdata)
        .then(() => {
            
            this.working = false
            this.exported = true
            //console.log(response)

            // Remove the orders from this screen
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
     }
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) { 
            if(  u.checked == 1) 
            {
              return 1
            }
          })
          return filteredOrders
     },
     ordersToUpdate: function () {
        const ordersToUpdate = this.filteredOrders.map( (order) => order.orderID )

        return ordersToUpdate
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           
           //this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }
      
  },
  watch: {
    makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

